var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.openModal
    ? _c("div", [
        _c(
          "div",
          {
            staticClass: "modal fade show",
            staticStyle: { display: "block" },
            attrs: {
              id: "go-modal-add-agent",
              tabindex: "-1",
              "aria-hidden": "true",
            },
          },
          [
            _c("div", { staticClass: "modal-dialog go-modal-add-agent" }, [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("div", { staticClass: "go-text-wrap" }, [
                    _c("div", { staticClass: "modal-title" }, [
                      _vm._v(_vm._s(_vm.$t("briefing.companyAgentsDetail"))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn go-btn-icon close",
                      attrs: { type: "button", "data-dismiss": "modal" },
                      on: { click: _vm.close },
                    },
                    [_c("i", { staticClass: "go-icon-24 go-icon-close" })]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c(
                    "div",
                    { staticClass: "go-list-wrap" },
                    [
                      _c(
                        "vue-custom-scrollbar",
                        {
                          staticClass: "go-modal-inner overflow-y-scroll",
                          nativeOn: {
                            scroll: function ($event) {
                              return _vm.infinityScroll.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "go-agent-card-wrap" }, [
                            _c("div", { staticClass: "go-widget-card" }, [
                              _c("div", { staticClass: "go-widget-header" }, [
                                _c("div", { staticClass: "go-elements" }, [
                                  _c(
                                    "div",
                                    { staticClass: "go-widget-title" },
                                    [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(
                                            _vm.$t("briefing.filter.all")
                                          ) +
                                          " "
                                      ),
                                      _c("small", [
                                        _vm._v(
                                          "(" +
                                            _vm._s(_vm.companyAgents.length) +
                                            ")"
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "go-form-group" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "autotrim",
                                        rawName: "v-autotrim",
                                      },
                                    ],
                                    staticClass: "go-form-control",
                                    attrs: {
                                      type: "text",
                                      placeholder: _vm.$t("briefing.search"),
                                    },
                                    on: {
                                      keyup: function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        ) {
                                          return null
                                        }
                                        return _vm.search.apply(null, arguments)
                                      },
                                    },
                                  }),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "go-list-wrap" }, [
                                _c(
                                  "div",
                                  { staticClass: "go-card-main-grid" },
                                  _vm._l(
                                    _vm.companyAgents,
                                    function (item, index) {
                                      return _c("company-briefing-agent-card", {
                                        key:
                                          (item.bpId &&
                                            item.bpId.concat("_" + index)) ||
                                          (item.other_info.requestId &&
                                            item.other_info.requestId.concat(
                                              "_" + index
                                            )) ||
                                          new Date()
                                            .getTime()
                                            .toString()
                                            .concat("_" + index),
                                        attrs: { "form-model": item },
                                        on: {
                                          "view-detail": function ($event) {
                                            return _vm.viewDetail(item)
                                          },
                                          "view-detail-report": _vm.viewDetail,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _vm.isLoading ? _c("list-loading") : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "modal-backdrop fade show" }),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }